import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NplexAnswersService } from 'src/app/services/nplex-answers.service';
import { NplexAnswersCombinedResult } from 'src/app/dtos/nplex-answers-combined-result.dto';
import { OffenderBlockList } from 'src/app/dtos/offender-block-list.dto';
import { DateUtility } from 'src/app/utilities/date-utility';

@Component({
  selector: 'app-search-results',
  templateUrl: './search-results.component.html',
  styleUrls: ['./search-results.component.css'],
})
export class SearchResultsComponent implements OnInit {
  public blockedTransactionTimestamp: string = '';
  public offenderBlockListRecords: OffenderBlockList[] = [];
  public results: NplexAnswersCombinedResult[] = [];
  public transactionId: string = '';

  public constructor(
    private readonly dateUtility: DateUtility,
    private readonly nplexAnswersService: NplexAnswersService,
    private readonly router: Router
  ) {
    this.results = this.nplexAnswersService.getNplexAnswersCombinedResults();
    this.transactionId = this.nplexAnswersService.getTransactionId();
    this.findBlockedTransactionTimestamp();
    this.findOffenderBlockList();
  }

  public ngOnInit(): void {
    if (!this.results.length) {
      this.router.navigate(['/search-page']);
    }
  }

  public findBlockedTransactionTimestamp(): void {
    const resultWithTransactionId = this.results.find(
      (result) => result.transactionSid === this.transactionId
    );

    if (!resultWithTransactionId) {
      return;
    }

    // get timeZone and UTC timestamp for format localized timestamp string
    let timestamp: string = resultWithTransactionId.transactionTs;
    const timeZone: string = resultWithTransactionId.pharmacyTimeZoneCode;
    // need a UTC timestamp with a 'Z' on the end
    timestamp = timestamp.endsWith('Z') ? timestamp : `${timestamp}Z`;
    
    this.blockedTransactionTimestamp = this.dateUtility.localizeUTCTimestamp(timestamp, timeZone); 
  }

  public findOffenderBlockList(): void {
    const resultWithOffenderBlockList = this.results.find(
      (result) =>
        result.offenderBlockListResult && result.offenderBlockListResult.length
    );

    this.offenderBlockListRecords = resultWithOffenderBlockList
      ? resultWithOffenderBlockList.offenderBlockListResult
      : [];
  }

  public getBlockListMessage(offenderBlockList: OffenderBlockList): string {
    return `According to data supplied during Transaction ${offenderBlockList.transactionSid}, ` +
      `your transaction was blocked due to a matching block list record supplied by: ${offenderBlockList.stateDesc}. ` +
      `This effectively means that you are no longer allowed to purchase products used in the manufacture of methamphetamine in: ${offenderBlockList.stateDesc}.`;
  }
}
